const ACTION = {
    UPDATE_GLOBAL_MODAL: 'UPDATE_GLOBAL_MODAL',
    UPDATE_GLOBAL_MODAL_ONLY: 'UPDATE_GLOBAL_MODAL_ONLY',
}

export default ACTION;
